import React, { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";
import { AvailabilityScheduleData } from "../../data/AvailabilitySchedule.Data";
import FormCreator from "../../../../components/forms/FormCreator.js";
import BasicDetailContext from "../../utils/BasicDetailContext";
import CourseLocation from "./component/CourseLocation";
import ZoomAccount from "./component/ZoomAccount";
import handleFieldChange from "./utils/handleFieldChange";
import NoOfSeats from "./component/NoOfSeats";
import { useAddEditEventLessonTimeSlotDetailsMutation, useDeleteEventTimeSlotByIdMutation, useLazyGetLessonTimeSlotDetailsByIdQuery } from "../../../../app/services/EventManagement/EventManagementApi.js";
import Buttons from "../../../../components/ui/button/Buttons.js";
import { generateEventsRequest } from "./utils/createRequestForEventSlot.js";
import SwalAlert from "../../../../services/swalService/SwalService.js";
import CenterModel from "../../../../components/ui/centerModel/CenterModel.js";
import SessionEditForm from "./component/SessionEditForm";

const AvailabilitySchedule = forwardRef((props, ref) => {
  const availblityScheduleRef = useRef();
  const courseLocationRef = useRef();
  const zoomAccountRef = useRef();
  const noOfSeatsRef = useRef();
  // const scheduleListRef = useRef(null);
  const { eventId, entryType, setEntryType, scheduleType, setScheduleType, ScheduleListData, setScheduleListData, eventTimeSlotId, setEventTimeSlotId } = useContext(BasicDetailContext);
  const [availblityScheduleForm, setAvailblityScheduleForm] = useState(AvailabilityScheduleData);
  const [openAddModalPopup, setOpenAddModalPopup] = useState(false); // Modal visibility state
  const { error, success, confirm } = SwalAlert();
  const [editForm, setEditForm] = useState();

  const [addEventLessionMutation, { isLoading: isLoadingLession, isSuccess: isSuccessLession, data: addEventLessionResponse }] = useAddEditEventLessonTimeSlotDetailsMutation();
  const [getLessionTimeSlotListByEventId, { isLoading: isGetListLoading, isSuccess: isGetListSuccess, data: eventListResponse }] = useLazyGetLessonTimeSlotDetailsByIdQuery();
  const [deleteTimeSlotById, { isLoading: isDeleteLoading, isSuccess: isDeleteSuccess, data: deleteTimeSlotResponse }] = useDeleteEventTimeSlotByIdMutation();

  // useEffect(() => {
  //   getLessionTimeSlotListByEventId({ eventId: eventId });
  // }, [])

  useEffect(() => {
    if (!isDeleteLoading && isDeleteSuccess && deleteTimeSlotResponse) {
      success("Sessions have been deleted successfully !", "Success");
      getLessionTimeSlotListByEventId({ eventId: eventId });
    }
  }, [isDeleteLoading, isDeleteSuccess, deleteTimeSlotResponse]);

  useEffect(() => {
    if (!isLoadingLession && isSuccessLession && addEventLessionResponse) {
      success("Sessions have been added successfully !", "Success");
      setEventTimeSlotId(addEventLessionResponse?.keyId)
      getLessionTimeSlotListByEventId({ eventId: eventId });
      // setTimeout(() => {
      //   scheduleListRef?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      // }, 100);
    }
  }, [isLoadingLession, isSuccessLession, addEventLessionResponse]);

  useEffect(() => {
    if (!isGetListLoading && isGetListSuccess && eventListResponse) {
      // debugger;
      const ScheduleList = eventListResponse?.entryTimeSlotList.map(timeSlot => {
        return {
          ...timeSlot,
          entryLessonObj: eventListResponse?.entryLessonList.filter(lesson => lesson.eventTimeSlotId === timeSlot.eventTimeSlotId),
        };
      });
      setScheduleListData(ScheduleList);
    }
  }, [isGetListLoading, isGetListSuccess, eventListResponse]);

  useImperativeHandle(ref, () => ({
    availblityScheduleRef: {
      getFormData: () => {
        const availblityScheduleData = availblityScheduleRef.current.getFormData();
        if (availblityScheduleData) {
          return availblityScheduleData;
        }
        return null;
      },
    },
    courseLocationRef: {
      getFormData: () => {
        const courseLocationData = courseLocationRef.current.getFormData();
        if (courseLocationData) {

          return courseLocationData;
        }
        return null;
      },
    },
    zoomAccountRef: {
      getFormData: () => {
        const zoomAccountData = zoomAccountRef.current.getFormData();
        if (zoomAccountData) {
          return zoomAccountData;
        }
        return null;
      },
    },
    noOfSeatsRef: {
      getFormData: () => {
        const noOfSeatsData = noOfSeatsRef.current.getFormData();
        if (noOfSeatsData) {
          return noOfSeatsData;
        }
        return null;
      },
    },
  }));

  // Memoized handler for optimized field changes
  const memoizedHandleFieldChange = (dataFieldName, updateFormData) => {
    handleFieldChange(dataFieldName, updateFormData, AvailabilityScheduleData, setScheduleType);
  }

  const handleGenerate = () => {
    const noOfSeatData = noOfSeatsRef?.current?.getFormData();
    const availblityScheduleData = availblityScheduleRef?.current?.getFormData();

    let courseLocationData = null;
    let zoomAccountData = null;

    switch (scheduleType) {
      case "zoom":
        zoomAccountData = zoomAccountRef?.current?.getFormData();
        break;
      case "physical":
        courseLocationData = courseLocationRef?.current?.getFormData();
        break;
      case "hybrid":
        courseLocationData = courseLocationRef?.current?.getFormData();
        zoomAccountData = zoomAccountRef?.current?.getFormData();
        break;
      default:
        return false;
    }

    const EventTimeSlotId = null;
    const EventLessonIndex = null;
    const EventLocationId = null;
    const Address = courseLocationData?.address || null;
    const ZoomMeetingId = zoomAccountData?.zoomAccountId;
    const ZoomWebinarId = zoomAccountData?.zoomAccountId;
    const OtherZoomDetail = null;
    const HowToGetThere = courseLocationData?.howToGetThere || null;
    const noOfEventsRequest = generateEventsRequest(noOfSeatData, eventId, EventTimeSlotId, EventLessonIndex, EventLocationId, Address, ZoomMeetingId, ZoomWebinarId, OtherZoomDetail, HowToGetThere);
    const request = {
      EventTimeSlotId: EventTimeSlotId || null,
      EventId: eventId || null,
      IsRedirection: availblityScheduleData?.isRedirection === "yes" || false,
      RedirectURL: availblityScheduleData?.redirectURL || null,
      IsPhysical: scheduleType === "physical" || false,
      IsOnline: scheduleType === "zoom" || false,
      IsHybrid: scheduleType === "hybrid" || false,
      AvailableSessions: noOfSeatData?.sessionNumbers || null,
      AvailableSeats: noOfSeatData?.seatsNumber || null,
      TimeSlotDate: noOfSeatData?.date_1 || null,
      EventStartTime: noOfSeatData?.startAt_1 || null,
      EventEndTime: noOfSeatData?.endsAt_1 || null,
      PostalCode: courseLocationData?.postalCode || null,
      ZoneId: null,
      LocationId: EventLocationId || null,
      GoogleMapPath: null,
      Latitude: null,
      Longitude: null,
      ZoomAccountId: zoomAccountData?.zoomAccountId || null,
      HowToGetThere: courseLocationData?.howToGetThere || null,
      EntryLessonList: noOfEventsRequest || [],
    }
    addEventLessionMutation(request);
  }

  const handleDelete = (eventTimeSlotId) => {
    confirm('Delete?', 'Are you sure you want to Delete?', 'Delete', 'Cancel').then((confirmed) => {
      if (confirmed) {
        let request = {
          Id: eventTimeSlotId || null,
          DeletedBy: eventId || null,
          AppId: eventId,
        }
        deleteTimeSlotById(request);
      }
    });
  }

  /* Add Member Modal Toggle */
  const handleEditMember = (item, availableSeats, bookedSeats, sessionLabel, eventId) => {
    console.log({ ...item, availableSeats, bookedSeats, sessionLabel, eventId }, 'test')
    debugger

    setEditForm({ ...item, availableSeats, bookedSeats, sessionLabel, eventId })
    setOpenAddModalPopup(!openAddModalPopup);
  };

  const handleModelClose = () => {
    setOpenAddModalPopup(false);
  };

  return (
    <div>
      <div class="container-fluid mt-4">
        <table class="table table-bordered">
          {ScheduleListData?.map((item, index) => {
            const sessionLabelPrefix = String.fromCharCode(65 + index); // 'A', 'B', 'C', etc.
            return <React.Fragment>
              <thead class="table-light">
                <tr>
                  <th>Sessions</th>
                  <th>Schedules</th>
                  <th>Qty</th>
                  <th>Seat Booked</th>
                  <th>
                    <Buttons
                      buttonText="Delete"
                      buttonTypeClassName="theme-btn btn mt-auto"
                      onClick={() => handleDelete(item?.eventTimeSlotId)}
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {item?.entryLessonObj?.map((lesson, lessonIndex) => (
                  <tr key={lesson.eventLessonId}>
                    <td>{`${sessionLabelPrefix}${lessonIndex + 1}`}</td>
                    <td>
                      <p>
                        <strong>Start Date:</strong> {new Date(item.timeSlotDate).toLocaleDateString()}<br />
                        <strong>Start Time:</strong> {item.eventStartTime} <br />
                        <strong>End Time:</strong> {item.eventEndTime} <br />
                        <strong>Address:</strong> {item.entryLessonObj[0]?.address || "N/A"}
                      </p>
                    </td>
                    <td>{item.availableSeats}</td>
                    <td>{item.bookedSeats}</td>
                    <td>
                      <Buttons
                        buttonText="Edit"
                        buttonTypeClassName="theme-btn btn mt-auto"
                        onClick={() => handleEditMember(lesson, item.availableSeats, item.bookedSeats, `${sessionLabelPrefix}${lessonIndex + 1}`, item.eventId)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </React.Fragment>
          })}
        </table>
      </div>
      <FormCreator
        config={availblityScheduleForm}
        ref={availblityScheduleRef}
        key={false}
        onColumnChange={memoizedHandleFieldChange}
      />
      {scheduleType === "physical" &&
        <React.Fragment>
          <CourseLocation ref={courseLocationRef} />
        </React.Fragment>
      }
      {scheduleType === "zoom" &&
        <React.Fragment>
          <ZoomAccount ref={zoomAccountRef} />
        </React.Fragment>
      }
      {scheduleType === "hybrid" &&
        <React.Fragment>
          <ZoomAccount ref={zoomAccountRef} />
          <CourseLocation ref={courseLocationRef} />
        </React.Fragment>
      }
      <NoOfSeats ref={noOfSeatsRef} />
      <div className="row mt-5">
        <div className="col-lg-12">
          <Buttons
            buttonText="Generate"
            buttonTypeClassName="theme-btn btn mt-auto"
            onClick={handleGenerate}
          />
        </div>
      </div>
      {/* <div><SessionEditForm/></div> */}

      {openAddModalPopup && (
        <CenterModel
          modelTitle="Edit Lesson"
          show
          // isLoading={isAddMemberLoading}
          // isDisable={isAddMemberLoading}
          handleClose={handleEditMember}
        >
          <SessionEditForm initState={editForm} isModelClose={handleModelClose} />
        </CenterModel>
      )}
    </div>
  );
});

export default AvailabilitySchedule;
